export default __webpack_public_path__ + "static/media/step2aLightMode.8f6c5e9d.svg";